// !!ВАЖНО
// для поля event обязателен прификс "for_ga"

const sendEvent = ({
  event,
  eventCategory,
  eventAction = null,
  eventLabel = null
}) => {
  (window.dataLayer || []).push({
    event,
    eventCategory,
    eventAction,
    eventLabel
  });
};

const gaReducer = (event, payload = {}) => {
  if (process.env.NODE_ENV === "development") {
    console.log({ type: event, payload });
  }
  switch (event) {
    case "TRIGGER_INTERVALS_SHOW":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_exp_time_show"
      });
    case "TRIGGER_STOCKS_SHOW":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_asset_show",
        eventLabel: payload.stock
      });
    case "TRIGGER_STOCKS_CLICK":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_asset_click",
        eventLabel: payload.stock
      });
    case "TRIGGER_PERCENT_SHOW":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_asset_ppercent_show",
        eventLabel: payload.stock
      });
    case "TRIGGER_PERCENT_CLICK":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_asset_ppercent_click",
        eventLabel: payload.stock
      });
    case "TRIGGER_BALANCE_SHOW":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_divide_balance_show"
      });
    case "TRIGGER_LOSS_SHOW":
      return sendEvent({
        event: "for_ga-disp-popup-trade-events",
        eventCategory: "disp-popup-trade-events",
        eventAction: "popup-trade-events_stop_show"
      });
    case "EARLY_SALE_POPUP_SHOW":
      return sendEvent({
        event: "for_ga-disp-early-trade-closure",
        eventCategory: "disp-early-trade-closure"
      });
    case "IOS_WEBAPP_POPUP_SHOW":
      return sendEvent({
        event: "for_ga-show-popup-webapp-ios",
        eventCategory: "install-webapp-ios"
      });
    case "WEBAPP_SHOW":
      return sendEvent({
        event: "for_ga_webapp_manifest",
        eventCategory: "webapp_manifest",
        eventAction: "webapp_manifest_show"
      });
    case "WEBAPP_ACCEPT":
      return sendEvent({
        event: "for_ga_webapp_manifest",
        eventCategory: "webapp_manifest",
        eventAction: "cl-webapp_manifest_install"
      });
    case "WEBAPP_NOTNOW":
      return sendEvent({
        event: "for_ga_webapp_manifest",
        eventCategory: "webapp_manifest",
        eventAction: "cl-webapp_manifest_cancel"
      });
    case "WEBAPP_INSTALL":
      return sendEvent({
        event: "for_ga_webapp_manifest",
        eventCategory: "webapp_manifest",
        eventAction: "cl-webapp_manifest_browser_install"
      });
    case "WEBAPP_DECLINE":
      return sendEvent({
        event: "for_ga_webapp_manifest",
        eventCategory: "webapp_manifest",
        eventAction: "cl-webapp_manifest_browser_cancel"
      });
    case "CLICKBTN_LOGIN_MAINPAGE": //Нажатие кнопки "Login" на главной странице
      return sendEvent({
        event: "for_ga-cl-main-login_btn",
        eventCategory: "cl-main-login_btn",
        eventAction: payload.userId
      });
    case "CLICKBTN_REGISTER_MAINPAGE": //Нажатие кнопки "Register" на главной странице
      return sendEvent({
        event: "for_ga-cl-main-reg_btn",
        eventCategory: "cl-main-reg_btn",
        eventAction: payload.userId
      });
    case "SUCCESS_REGISTARTION": //Успешная регистрация
      return sendEvent({
        event: "for_ga-bk-reg_success",
        eventCategory: "bk-reg_success",
        eventAction: payload.userId,
        eventLabel: payload.regType // email / facebook / google
      });
    case "CLICKBTN_SOCIALREGISTER_MAINPAGE": //Нажатие кнопки "Register" на главной странице после регистрации через соц. сеть
      return sendEvent({
        event: "for_ga-cl-main-soc_reg_btn",
        eventCategory: "cl-main-soc_reg_btn",
        eventAction: payload.userId
      });
    case "CLICKBTN_DOWNLOADAPP_MAINPAGE": //Клик по кнопке для загрузки мобильного приложения
      return sendEvent({
        event: "for_ga-cl-all-get_app",
        eventCategory: "cl-all-get_app",
        eventAction: payload.appSrc
      });
    case "CLICKBTN_OPENDEMOACC_MAINPAGE": //Клик по кнопке "Open Demo Account" на главной странице
      return sendEvent({
        event: "for_ga-cl-main-open_demo_acc",
        eventCategory: "cl-main-open_demo_acc"
      });
    case "CLICKLINK_FOOTER_MAINPAGE": //Клик по ссылкам в футере
      return sendEvent({
        event: "for_ga-cl-ftr-links",
        eventCategory: "cl-ftr-links",
        eventAction: payload.linkUrl,
        eventLabel: payload.linkText
      });
    case "CLICKBTN_SEARCH": //Клик по кнопке поиска
      return sendEvent({
        event: "for_ga-cl-all-search",
        eventCategory: "cl-all-search",
        eventAction: payload.searchQuery
      });
    case "CLICKBTN_REF_SHARE": // кнопки шэра реферальной ссылки
      return sendEvent({
        event: "for_ga-cl-all-referral_link_share",
        eventCategory: "cl-all-referral_link_share",
        eventAction: payload.clickId,
        eventLabel: payload.pagePath
      });
    case "CLICKBTN_FILLUP": // клик кнопки Pay на fillup
      return sendEvent({
        event: "for_ga-cl-deposit-pay_btn",
        eventCategory: "cl-deposit-pay_btn",
        eventAction: payload.paymentMethod,
        eventLabel: `${payload.amount}__${payload.bonusAmount}%`
      });
    case "CLICKBTN_VERIFY": // клик кнопки верификации в профиле
      return sendEvent({
        event: "for_ga-cl-profile-verification_btn",
        eventCategory: "cl-profile-verification_btn"
      });
    case "CLICKBTN_DEPOSIT_MAINPAGE": // клик кнопки депозит на главной
      return sendEvent({
        event: "for_ga-cl-main-deposit_btn",
        eventCategory: "cl-main-deposit_btn"
      });
    case "CLICKBTN_TRADE_MAINPAGE_HEADER":
      return sendEvent({
        event: "for_ga-cl-main-hdr-trade_now_btn",
        eventCategory: "cl-main-hdr-trade_now_btn"
      });
    case "CLICKBTN_DEPOSIT_MENU": // ссылка депозита в меню
      return sendEvent({
        event: "for_ga-cl-all-menu-deposit_btn",
        eventCategory: "cl-all-menu-deposit_btn"
      });
    case "CLICKLINK_NAVIGATION": // клик по ссылкам в меню
      return sendEvent({
        event: "for_ga-cl-all-menu-link",
        eventCategory: "cl-all-menu-link",
        eventAction: payload.linkUrl,
        eventLabel: payload.linkText
      });
    case "CLICKLINK_NAVIGATION_AB":
      return sendEvent({
        event: "for_ga-cl-all-menu-button",
        eventCategory: "cl-all-menu-button",
        eventAction: payload.linkUrl,
        eventLabel: payload.linkText
      });
    case "CLICKLINK_TRADE_DEPOSIT_HEADER":
      return sendEvent({
        event: "for_ga-cl-all-trade_deposit_btn",
        eventCategory: "cl-all-trade_deposit_btn",
        eventAction: payload.linkText,
        eventLabel: payload.pageUrl
      });
    case "CLICKBTN_TRADE_DEPOSIT_ACCOUNT":
      return sendEvent({
        event: "for_ga-cl-trade-trade_deposit_btn",
        eventCategory: "cl-trade-trade_deposit_btn",
        eventAction: payload.buttonText,
        eventLabel: payload.accountType
      });
    case "CLICKBTN_TRADE_ADD_MONEY":
      return sendEvent({
        event: "for_ga-cl-trade-add_money_btn",
        eventCategory: "cl-trade-add_money_btn"
      });
    case "CLICKBTN_PPP_DEPOSIT_SHOW":
      return sendEvent({
        event: "for_ga-disp-popup-demorefill",
        eventCategory: "disp-popup-demorefill",
        eventAction: "cl_popup2_show"
      });
    case "CLICKBTN_PPP_DEPOSIT_REFILL":
      return sendEvent({
        event: "for_ga-disp-popup-demorefill",
        eventCategory: "disp-popup-demorefill",
        eventAction: "cl_popup2_refill"
      });
    case "CLICKBTN_PPP_DEPOSIT_FILLUP":
      return sendEvent({
        event: "for_ga-disp-popup-demorefill",
        eventCategory: "disp-popup-demorefill",
        eventAction: "cl_popup2_fillup"
      });
    case "SHOW_TOUR":
      return sendEvent({
        event: "for_ga-disp-trade-tour_show",
        eventCategory: "disp-trade-tour_old"
      });
    case "CLICKBTN_GET_STARTED_TOUR":
      return sendEvent({
        event: "for_ga-cl-trade-start_tour_btn",
        eventCategory: "disp-trade-tour_old"
      });
    case "CLICKBTN_START_TOUR":
      return sendEvent({
        event: "for_ga-cl-trade-tour_to_start",
        eventCategory: "disp-trade-tour_old"
      });
    case "CLICKBTN_TRADE_TOUR":
      return sendEvent({
        event: "for_ga-cl-trade-tour_to_trade",
        eventCategory: "disp-trade-tour_old"
      });
    case "CLICKBTN_HELP_TOUR":
      return sendEvent({
        event: "for_ga-cl-trade-tour_to_help",
        eventCategory: "disp-trade-tour_old"
      });
    case "CLICKBTN_SHOW_TRADE_SETTINGS":
      return sendEvent({
        event: "for_ga-disp-trade-settings",
        eventCategory: "disp-trade-settings"
      });
    case "CLICKBTN_CHART_TYPE":
      return sendEvent({
        event: "for_ga-cl-trade-settings-chart_type",
        eventCategory: "cl-trade-settings-chart_type",
        eventAction: payload.buttonText
      });
    case "CLICKBTN_INTERVAL":
      return sendEvent({
        event: "for_ga-cl-trade-settings-intervals",
        eventCategory: "cl-trade-settings-intervals",
        eventAction: payload.buttonText
      });
    case "CLICKBTN_MOOD":
      return sendEvent({
        event: "for_ga-cl-trade-settings-indicator_tm",
        eventCategory: "cl-trade-settings-indicator_tm",
        eventAction: payload.value
      });
    case "CLICKBTN_INDICATOR":
      return sendEvent({
        event: "for_ga-cl-trade-settings-indicators",
        eventCategory: "cl-trade-settings-indicators",
        eventAction: payload.buttonText
      });
    case "CLICKBTN_THEME":
      return sendEvent({
        event: "for_ga-cl-trade-settings-theme",
        eventCategory: "cl-trade-settings-theme",
        eventAction: payload.buttonText
      });
    case "CLICKBTN_LINE":
      return sendEvent({
        event: "for_ga-cl-trade-settings-chart_line",
        eventCategory: "cl-trade-settings-chart_line",
        eventAction: payload.buttonText
      });
    case "CLICKBTN_SETTINGS_COLOR":
      return sendEvent({
        event: "for_ga-cl-trade-settings-chart_color",
        eventCategory: "cl-trade-settings-chart_color"
      });
    case "CLICKBTN_SOUND":
      return sendEvent({
        event: "for_ga-cl-trade-settings-sound_effects",
        eventCategory: "cl-trade-settings-sound_effects",
        eventAction: payload.value
      });
    case "CLICKBTN_CHANGE_THEME":
      return sendEvent({
        event: "for_ga-cl-trade-change_theme",
        eventCategory: "cl-trade-change_theme",
        eventAction: payload.theme
      });
    case "SHOW_TOURNAMENT_JOIN_POPUP":
      return sendEvent({
        event: "for_ga-disp-tournaments-join_window",
        eventCategory: "disp-tournaments-join_window"
      });
    case "CLICKBTN_JOIN_TOURNAMENT":
      return sendEvent({
        event: "for_ga-cl-tournaments-modal-join",
        eventCategory: "cl-tournaments-modal-join"
      });
    case "SHOW_TOURNAMENT_LEAVE_POPUP":
      return sendEvent({
        event: "for_ga-disp-tournaments-quit_window",
        eventCategory: "disp-tournaments-quit_window"
      });
    case "CLICKBTN_LEAVE_TOURNAMENT":
      return sendEvent({
        event: "for_ga-cl-tournaments-modal-quit",
        eventCategory: "cl-tournaments-modal-quit"
      });
    case "CLICKBTN_SAVE_NAME":
      return sendEvent({
        event: "for_ga-cl-profile-full_name",
        eventCategory: "cl-profile-full_name",
        eventAction: payload.name
      });
    case "CLICKBTN_SENDCODE_PROFILE":
      return sendEvent({
        event: "for_ga-cl-profile-send_code",
        eventCategory: "cl-profile-send_code"
      });
    case "CLICKBTN_CHANGE_PASSWORD":
      return sendEvent({
        event: "for_ga-cl-profile-change_pwd",
        eventCategory: "cl-profile-change_pwd"
      });
    case "CLICKBTN_PASSWORD_SUBMIT":
      return sendEvent({
        event: "for_ga-cl-profile-change_pwd_apply",
        eventCategory: "cl-profile-change_pwd_apply"
      });
    case "CLICKBTN_CHANGE_CONFIRMED_EMAIL":
      return sendEvent({
        event: "for_ga-cl-profile_change-email_btn",
        eventCategory: "cl-profile_change-email_btn"
      });
    case "CLICKBTN_SEND_EMAIL_CODE":
      return sendEvent({
        event: "for_ga-cl-profile_send-code_email_btn",
        eventCategory: "cl-profile_send-code_email_btn"
      });
    case "CLICKBTN_CHANGE_CONFIRMED_PHONE":
      return sendEvent({
        event: "for_ga-cl-profile_change-phone_btn",
        eventCategory: "cl-profile_change-phone_btn"
      });
    case "CLICKBTN_SEND_PHONE_CODE":
      return sendEvent({
        event: "for_ga-cl-profile_send-code_phone_btn",
        eventCategory: "cl-profile_send-code_phone_btn"
      });
    case "CLICKBTN_CHART_TIME":
      return sendEvent({
        event: "for_ga-cl-trade-history_length",
        eventCategory: "cl-trade-history_length",
        eventAction: payload.buttonText,
        eventLabel: payload.stock
      });
    case "CLICKBTN_TIME_MINUS":
      return sendEvent({
        event: "for_ga-cl-trade-workspace_farther",
        eventCategory: "cl-trade-workspace_farther",
        eventLabel: payload.stock
      });
    case "CLICKBTN_TIME_PLUS":
      return sendEvent({
        event: "for_ga-cl-trade-workspace_closer",
        eventCategory: "cl-trade-workspace_closer",
        eventLabel: payload.stock
      });
    case "CLICKBTN_TIME_NOW":
      return sendEvent({
        event: "for_ga-cl-trade-workspace_goto_now",
        eventCategory: "cl-trade-workspace_goto_now",
        eventLabel: payload.stock
      });
    case "CLICKBTN_STOCK":
      return sendEvent({
        event: "for_ga-cl-trade-workspace_assets",
        eventCategory: "cl-trade-workspace_assets",
        eventAction: payload.buttonText
      });
    case "CLICKBTN_OPEN_DEMO":
      return sendEvent({
        event: "for_ga-cl-main-open_demo_acc",
        eventCategory: "cl-main-open_demo_acc",
        eventAction: payload.pageUrl
      });
    case "CLICKBTN_BOTTOM_TRADE":
      return sendEvent({
        event: "for_ga-cl-main-ftr-trade_now_btn",
        eventCategory: "cl-main-ftr-trade_now_btn",
        eventAction: payload.pageUrl
      });
    case "CLICKBTN_UPPER_BET":
      return sendEvent({
        event: "for_ga-cl-trade-bet_upper",
        eventCategory: "cl-trade-bet",
        eventAction: "upper"
      });
    case "CLICKBTN_LOWER_BET":
      return sendEvent({
        event: "for_ga-cl-trade-bet_lower",
        eventCategory: "cl-trade-bet",
        eventAction: "lower"
      });
    case "CLICKBTN_CHANGE_LANG":
      return sendEvent({
        event: "for_ga-cl-all-change_lang",
        eventCategory: "cl-all-change_lang",
        eventAction: payload.lang
      });
    case "CLICKBTN_LATER_TOUR":
      return sendEvent({
        event: "for_ga-event-to-ga",
        eventCategory: "disp-trade-tour_old",
        eventAction: "show_later",
        eventLabel: "Показать тур позже"
      });
    case "CLICKBTN_GO_AFTER_TOUR":
      return sendEvent({
        event: "for_ga-event-to-ga",
        eventCategory: "disp-trade-tour_old",
        eventAction: payload.page,
        eventLabel: payload.pageLabel
      });
    case "SHOW_NEW_TOUR":
      return sendEvent({
        event: "for_ga-event-to-ga",
        eventCategory: "disp-trade-tour_old",
        eventAction: "shows-tour",
        eventLabel: "Показ нового тура"
      });
    case "TOUR_PAGE":
      return sendEvent({
        event: "for_ga-event-to-ga",
        eventCategory: "disp-trade-tour_old",
        eventAction: payload.slide,
        eventLabel: payload.slideText
      });
    case "SHOW_TOUR_3000":
      return sendEvent({
        event: "for_ga-disp-trade-tour_new1_show",
        eventCategory: "disp-trade-tour_new1",
        eventAction: "for_ga-disp-trade-tour_new1_show"
      });
    case "SHOW_LATER_TOUR_3000":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new1_later_btn",
        eventCategory: "disp-trade-tour_new1",
        eventAction: "for_ga-cl-trade-tour_new1_later_btn"
      });
    case "SHOW_STEP_TOUR_3000":
      return sendEvent({
        event: `for_ga-trade-tour_new1_step${payload.step}`,
        eventCategory: "disp-trade-tour_new1",
        eventAction: `for_ga-trade-tour_new1_step${payload.step}`
      });
    case "CLICK_TRADE_TOUR_3000":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new1_to_trade",
        eventCategory: "disp-trade-tour_new1",
        eventAction: "for_ga-cl-trade-tour_new1_to_trade"
      });
    case "CLICK_HELP_TOUR_3000":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new1_to_help",
        eventCategory: "disp-trade-tour_new1",
        eventAction: "for_ga-cl-trade-tour_new1_to_help"
      });
    case "SHOW_TOUR_3001":
      return sendEvent({
        event: "for_ga-disp-trade-tour_new2_show",
        eventCategory: "disp-trade-tour_new2",
        eventAction: "for_ga-disp-trade-tour_new2_show"
      });
    case "SHOW_LATER_TOUR_3001":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new2_later_btn",
        eventCategory: "disp-trade-tour_new2",
        eventAction: "for_ga-cl-trade-tour_new2_later_btn"
      });
    case "SHOW_STEP_TOUR_3001":
      return sendEvent({
        event: `for_ga-trade-tour_new2_step${payload.step}`,
        eventCategory: "disp-trade-tour_new2",
        eventAction: `for_ga-trade-tour_new2_step${payload.step}`
      });
    case "CLICK_TRADE_TOUR_3001":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new2_to_trade",
        eventCategory: "disp-trade-tour_new2",
        eventAction: "for_ga-cl-trade-tour_new2_to_trade"
      });
    case "CLICK_HELP_TOUR_3001":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new2_to_help",
        eventCategory: "disp-trade-tour_new2",
        eventAction: "for_ga-cl-trade-tour_new2_to_help"
      });
    case "CLICK_SKIP_TOUR_3000":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new1_later_btn",
        eventCategory: "disp-trade-tour_new1",
        eventAction: `new1tour-skip-step${payload.step}`
      });
    case "CLICK_SKIP_TOUR_3001":
      return sendEvent({
        event: "for_ga-cl-trade-tour_new2_later_btn",
        eventCategory: "disp-trade-tour_new2",
        eventAction: `new2tour-skip-step${payload.step}`
      });
    case "ACTIVATE_TOUR_FROM_SIDEBAR":
      return sendEvent({
        event: "for_ga-cl-trade-tour_from",
        eventCategory: "enter-trade-tour",
        eventAction: "tour_from_menu"
      });
    case "ACTIVATE_TOUR_FROM_ICON":
      return sendEvent({
        event: "for_ga-cl-trade-tour_from",
        eventCategory: "enter-trade-tour",
        eventAction: "tour_from_icon"
      });
    case "ACTIVATE_TOUR_FROM_HELPDESK":
      return sendEvent({
        event: "for_ga-cl-trade-tour_from",
        eventCategory: "enter-trade-tour",
        eventAction: "tour_from_hc"
      });
    case "IRONCARD_POLL_YES":
      return sendEvent({
        event: "for_ga-cl-ironcard_poll_yes",
        eventCategory: "cl-ironcard_poll",
        eventAction: "ironcard_poll_yes"
      });
    case "IRONCARD_POLL_NO":
      return sendEvent({
        event: "for_ga-cl-ironcard_poll_no",
        eventCategory: "cl-ironcard_poll",
        eventAction: "ironcard_poll_no"
      });
    case "CLICK_MOBILE_SETTINGS":
      return sendEvent({
        event: "for_ga-cl-settings-mobile-link",
        eventCategory: "cl-settings-mobile-link",
        eventAction: "for_ga-cl-settings-mobile-link"
      });
    case "CLICK_MOBILE_DEALS":
      return sendEvent({
        event: "for_ga-cl-deals-mobile-link",
        eventCategory: "cl-deals-mobile-link",
        eventAction: "for_ga-cl-deals-mobile-link"
      });
    case "OPEN_SOCIAL_TRADING":
      return sendEvent({
        event: "for_ga-cl-social-trading-on",
        eventCategory: "cl-social-trading-on",
        eventAction: "social-trading-on"
      });
    case "CLOSE_SOCIAL_TRADING":
      return sendEvent({
        event: "for_ga-cl-social-trading-off",
        eventCategory: "cl-social-trading-off",
        eventAction: "social-trading-off"
      });
    case "CLICK_SOCIAL_TRADING_ASSET":
      return sendEvent({
        event: "for_ga-cl-social-trading-asset",
        eventCategory: "cl-social-trading-asset",
        eventAction: "social-trading-asset",
        eventLabel: payload.asset
      });
    case "DEAL_COMPENSATED":
      return sendEvent({
        event: "for_ga_safe_deal",
        eventCategory: "safe_deal",
        eventAction: "safe_deal_used",
        eventLabel: payload.amount
      });
    case "CANCEL_COMPENSATE":
      return sendEvent({
        event: "for_ga_safe_deal",
        eventCategory: "safe_deal",
        eventAction: "safe_deal_notused_trade",
        eventLabel: payload.amount
      });
    case "COMPENSATE_TIMEOUT":
      return sendEvent({
        event: "for_ga_safe_deal",
        eventCategory: "safe_deal",
        eventAction: "safe_deal_notused_time",
        eventLabel: payload.amount
      });
    case "CLOSE_TOUR":
      return sendEvent({
        event: "for_ga_cl-trade-tour_old_later_btn",
        eventCategory: "disp-trade-tour_old",
        eventAction: `tour_old-skip-step${payload.currentSlide}`
      });
    case "START_TEST_FOR_USERS":
      return sendEvent({
        event: "for_ga-disp-test-for-users",
        eventCategory: "disp-test-for-users",
        eventAction: `disp-test-for-users_test_start`
      });
    case "REFUSE_TEST_FOR_USERS":
      return sendEvent({
        event: "for_ga-disp-test-for-users",
        eventCategory: "disp-test-for-users",
        eventAction: `disp-test-for-users_test_refuse`
      });
    case "ANSWER_TEST_FOR_USERS":
      return sendEvent({
        event: "for_ga-disp-test-for-users",
        eventCategory: "disp-test-for-users",
        eventAction: `disp-test-for-users_test_answer_${
          payload.questionNumber
        }`,
        eventLabel: payload.answerText
      });
    case "TO_TRADE_TEST_FOR_USERS":
      return sendEvent({
        event: "for_ga-disp-test-for-users",
        eventCategory: "disp-test-for-users",
        eventAction: `disp-test-for-users_test_to_trade`
      });
    case "SHOW_RATE_APP_POPUP":
      return sendEvent({
        event: "for_ga-app-rate",
        eventCategory: "disp-app-rate",
        eventAction: "disp-app-rate-display"
      });
    case "SET_POSITIVE_APP_RATING":
      return sendEvent({
        event: "for_ga-app-rate",
        eventCategory: "disp-app-rate",
        eventAction: "disp-app-rate-positive",
        eventLabel: payload.rate
      });
    case "SET_NEGATIVE_APP_RATING":
      return sendEvent({
        event: "for_ga-app-rate",
        eventCategory: "disp-app-rate",
        eventAction: "disp-app-rate-negative",
        eventLabel: payload.rate
      });
    case "LATER_APP_RATING":
      return sendEvent({
        event: "for_ga-app-rate",
        eventCategory: "disp-app-rate",
        eventAction: "disp-app-rate-later"
      });
    case "SELECT_WITHDRAW_TOUR":
      return sendEvent({
        event: "for_ga-event-to-ga",
        eventCategory: "disp-trade-tour_old",
        eventAction: "cl-withdrawal",
        eventLabel: payload.withdrawMethod
      });
    case "RATE_APP_ERROR":
      return sendEvent({
        event: "for_ga-app-rate",
        eventCategory: "error-app-rate",
        eventAction: "error-app-rate-submit",
        eventLabel: payload.error
      });
    case "BELL_OPEN":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "disp-bell"
      });
    case "BELL_ALL_TOURNAMENTS_CLICK":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-all_tournaments"
      });
    case "BELL_ALL_NEWS_CLICK":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-all_news"
      });
    case "BELL_GO_TO_TOURNAMENT":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-enter_tournament",
        eventLabel: payload.type
      });
    case "BELL_GO_TO_NEWS":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-open_news_article",
        eventLabel: payload.title
      });
    case "BELL_GO_TO_PROMO":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-use_bonus_promocode"
      });
    case "BELL_GO_TO_SUCCESS_DEPOSIT":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-success_deposit"
      });
    case "BELL_GO_TO_SUCCESS_WITHDRAWAL":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-success_withdrawal"
      });
    case "BELL_GO_TO_TOURNAMENT_INVITE":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-enter_tournament_by_invitation"
      });
    case "BELL_GO_TO_SAFE_DEALS":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-get_bonus_safe_deals"
      });
    case "BELL_SUCCESS_VERIFICATION":
      return sendEvent({
        event: "for_ga-cl-bell",
        eventCategory: "cl-bell",
        eventAction: "cl-verification_approve"
      });
    case "SHOW_VIDEO_TOUR":
      return sendEvent({
        event: "for_ga-trade-tour_video",
        eventCategory: "trade-tour_video",
        eventAction: "trade-tour_video-display"
      });
    case "CLICKBTN_LATER_VIDEO_TOUR":
      return sendEvent({
        event: "for_ga-trade-tour_video",
        eventCategory: "trade-tour_video",
        eventAction: "trade-tour_video-later"
      });
    case "CLICKBTN_SKIP_VIDEO_TOUR":
      return sendEvent({
        event: "for_ga-trade-tour_video",
        eventCategory: "trade-tour_video",
        eventAction: "trade-tour_video-skip"
      });
    case "END_VIDEO_TOUR":
      return sendEvent({
        event: "for_ga-trade-tour_video",
        eventCategory: "trade-tour_video",
        eventAction: "trade-tour_video-complete"
      });
    case "TOUR_VIDEO_TO_TRADE":
      return sendEvent({
        event: "for_ga-trade-tour_video",
        eventCategory: "trade-tour_video",
        eventAction: "trade-tour_video-to_trade"
      });
    case "TOUR_VIDEO_TO_HELPDESK":
      return sendEvent({
        event: "for_ga-trade-tour_video",
        eventCategory: "trade-tour_video",
        eventAction: "trade-tour_video-to_helpdesk"
      });
    default:
      return false;
  }
};

export { gaReducer };



// WEBPACK FOOTER //
// ./src/components/GA/index.js